export default __webpack_public_path__ + "static/media/del_icon.8cd49a2d.svg";